import React, { useEffect } from 'react';
import ProBg from "./proBg.jpg"
const ColdRolled = () => {
    useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when this page loads
  }, []);
  return (
    <div>
      <section
        className="featured-job-area section-padding30 section-bg2"
        style={{
        backgroundImage: `url(${ProBg})`,  backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',  // Adjust the height here
        }}
      >
        <div className="container">
          <div className="row justify-content">
            <div className="col-xl-7 col-lg-9 col-md-10 col-sm-12">
              {/* Section Title */}
              <div className="section-tittle text-left mb-80">
                <h2>Cold Rolled Coils & Sheets</h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            {/* Add content here */}
          </div>
        </div>
      </section>

      <section className="about-low-area section-padding2" style={{ marginTop: '-50px' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-10">
              <div className="about-caption mb-11">
                <div className="section-tittle mb-11">
                  {/* <span>About Al Hadeed Steel</span> */}
                  {/* <h2>Building the Future with Strength and Durability</h2> */}
                </div>
                <p style={{lineHeight:"2.4"}}>

<p style={{lineHeight:"2.4"}}>Cold rolled coils and sheets, also referred to as cold reduced coils, CRC (Cold Rolled Coils), or flat steel products, are finished steel products processed to achieve superior surface quality and precise dimensions. These products are produced by passing a hot rolled sheet or strip, previously pickled to remove scale, through cold rolls below the metal's recrystallization temperature. The cold rolling process enhances the material's surface finish, uniformity, and strength, making it suitable for high-end applications.</p>
<p style={{lineHeight:"2.4"}}>Flat steel coil products are categorized based on their dimensions. Products with widths less than 600mm for hot rolled and less than 500mm for cold rolled products are commonly called narrow strips, while wider flat products are referred to as wide strips. Cold rolled coils and sheets are highly sought after in industries like automotive, construction, appliances, and manufacturing due to their superior qualities, including tighter tolerances, enhanced strength, and a smooth, polished finish.</p>
<p style={{lineHeight:"2.4"}}>Cold rolling results in thinner, more refined, and stronger materials compared to hot rolling alone. Additionally, cold rolled products can be further treated or coated for improved durability, corrosion resistance, and aesthetic appeal. These characteristics make them ideal for precision applications where performance and appearance are critical, such as in the production of car body panels, household appliances, furniture, and precision tools.</p>

 </p>
                
              </div>
            </div>
          </div>
                <div className="container my-4">
            <h2 className="text-center mb-4">Specifications of Cold Forming Steel</h2>
            <div className="table-responsive">
                <table class="table table-bordered text-center">
    <thead class="table-dark">
        <tr>
            <th colspan="2">Europe</th>
            <th>Germany</th>
            <th>France</th>
            <th>USA</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>EN 10149-2</td>
            <td>EN 10149-3</td>
            <td>WBL 092</td>
            <td>NFA 36-203</td>
            <td>ASTM A 656</td>
        </tr>
        <tr>
            <td>&ndash;</td>
            <td>&ndash;</td>
            <td>Q St E 260 N</td>
            <td>&ndash;</td>
            <td>&ndash;</td>
        </tr>
        <tr>
            <td>&ndash;</td>
            <td>S 260 NC</td>
            <td>&ndash;</td>
            <td>E 275 D</td>
            <td>&ndash;</td>
        </tr>
        <tr>
            <td>S 315 MC</td>
            <td>S 315 NC</td>
            <td>&ndash;</td>
            <td>&ndash;</td>
            <td>&ndash;</td>
        </tr>
        <tr>
            <td>&ndash;</td>
            <td>&ndash;</td>
            <td>Q St E 340 (N,TM)</td>
            <td>E 335 D</td>
            <td>&ndash;</td>
        </tr>
        <tr>
            <td>S 355 MC</td>
            <td>S 355 NC</td>
            <td>&ndash;</td>
            <td>&ndash;</td>
            <td>GR 50</td>
        </tr>
        <tr>
            <td>&ndash;</td>
            <td>&ndash;</td>
            <td>Q St E 380 (N, TM)</td>
            <td>E 390 D</td>
            <td>&ndash;</td>
        </tr>
        <tr>
            <td>S 420 MC</td>
            <td>S 420 NC</td>
            <td>Q St E 420 (N, TM)</td>
            <td>E 430 D</td>
            <td>GR 60</td>
        </tr>
        <tr>
            <td>&ndash;</td>
            <td>&ndash;</td>
            <td>&ndash;</td>
            <td>E 445 D</td>
            <td>&ndash;</td>
        </tr>
        <tr>
            <td>S 460 MC</td>
            <td>&ndash;</td>
            <td>Q St E 460 (N, TM)</td>
            <td>&ndash;</td>
            <td>&ndash;</td>
        </tr>
        <tr>
            <td>&ndash;</td>
            <td>&ndash;</td>
            <td>&ndash;</td>
            <td>E 490 D</td>
            <td>GR 70</td>
        </tr>
        <tr>
            <td>S 500 MC</td>
            <td>&ndash;</td>
            <td>Q St E 500 (N, TM)</td>
            <td>&ndash;</td>
            <td>&ndash;</td>
        </tr>
        <tr>
            <td>S 550 MC</td>
            <td>&ndash;</td>
            <td>&ndash;</td>
            <td>&ndash;</td>
            <td>GR 80</td>
        </tr>
    </tbody>
</table>

            </div>
        </div>
        </div>
      </section>
    </div>
  );
}

export default ColdRolled;
